import { askLoginAction } from './actions/hostActions'
import { getStore } from '@wellesley/store'
import { authSlice } from '@wellesley/auth/authSlice'
import { sendMessage } from '../common/message/sendMessage'

export const askLogin = () => {
  const isSameWindow = window.parent === window
  isSameWindow
    ? getStore().dispatch(authSlice.actions.setAskLoginOpen(true))
    : sendMessage({ action: askLoginAction() })
}
